export const ALLOWED = 'ALLOWED';
export const DENIED = 'DENIED';
